var _style, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29 29",
    style: {
      enableBackground: "new 0 0 29 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#9B9591;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,28.1c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S10.8,28.1,9.4,28.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.1,28.1c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S24.5,28.1,23.1,28.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,20.7c-0.8,0-1.6-0.3-2.3-0.8c-0.7-0.5-1.2-1.3-1.3-2.2l-2-9.2c0,0,0-0.1,0-0.1L3.5,3.2H2 C1.3,3.2,0.8,2.7,0.8,2S1.3,0.8,2,0.8h2.5c0.6,0,1.1,0.4,1.2,1L6.8,7H27c0.4,0,0.7,0.2,1,0.5s0.3,0.7,0.2,1.1l-2.1,9.3 c-0.2,0.8-0.6,1.6-1.3,2.1c-0.7,0.5-1.5,0.8-2.3,0.8L10.2,20.7C10.3,20.7,10.3,20.7,10.2,20.7z M7.4,9.5L9,17.2 c0.1,0.3,0.2,0.5,0.4,0.7c0.2,0.2,0.5,0.3,0.8,0.3h12.2c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.4-0.4,0.4-0.7l1.7-7.8H7.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.2048761819b2a52bdd5606edcbd53f43.svg";
export { ForwardRef as ReactComponent };